import { ChartCrosshairAxisLabel } from './ChartCrosshairAxisLabel';
import type { ChartHoverPoint, ChartPlot } from './types';

type ChartCrosshairProps = {
  activeHover: ChartHoverPoint<unknown>;
  plot: ChartPlot;
  axisLabels?: { x?: string; y?: string };
  horizontalLinePosition?: 'cursor' | 'point';
  showActiveCircle?: boolean;
  activeCircleColor?: string;
};

export const ChartCrosshair = ({
  activeHover,
  plot,
  axisLabels,
  horizontalLinePosition = 'cursor',
  showActiveCircle,
  activeCircleColor = 'currentColor',
}: ChartCrosshairProps) => {
  const { x, y, cursorY } = activeHover;
  const { top, bottom, left, right } = plot;

  const horizontalLineY = horizontalLinePosition === 'point' ? y : cursorY;

  return (
    <g data-testid="time-series-chart-crosshair" pointerEvents="none">
      <line
        x1={x}
        x2={x}
        y1={top}
        y2={bottom}
        stroke="var(--token-color-alphalight-400)"
        strokeWidth={1.5}
        strokeDasharray="4 4"
      />
      <line
        x1={left}
        x2={right}
        y1={horizontalLineY}
        y2={horizontalLineY}
        stroke="var(--token-color-alphalight-400)"
        strokeWidth={1.5}
        strokeDasharray="4 4"
      />
      {showActiveCircle && (
        <>
          <circle cx={x} cy={y} r={7} fill="var(--token-color-special-background-overlay)" />
          <circle cx={x} cy={y} r={3.5} fill={activeCircleColor} />
        </>
      )}
      {axisLabels?.x && (
        <ChartCrosshairAxisLabel axis="x" plot={plot} position={x} label={axisLabels.x} />
      )}
      {axisLabels?.y && (
        <ChartCrosshairAxisLabel
          axis="y"
          plot={plot}
          position={horizontalLineY}
          label={axisLabels.y}
        />
      )}
    </g>
  );
};
